<template>
  <md-sidenav class="main-sidebar md-left md-fixed" md-swipeable ref="main-sidebar">
    <md-toolbar class="vue-material-logo logo-main" md-theme="white">
      <router-link v-show="!loadingLogo" exact to="/admin">
        <img class="logo-main" :src="logoOrganization">
      </router-link>
    
      <div v-if="loadingLogo" class="md-toolbar-container">
        <md-spinner class="md-accent custom-spinner" :md-size="40" md-indeterminate></md-spinner>
      </div>
      
    </md-toolbar>

    <div class="main-sidebar-links">
      <md-list>
       <md-list-item class="user-info">
          <md-avatar class="md-avatar-icon">
            <md-icon>person</md-icon>
          </md-avatar>

          <div class="md-list-text-container">
            <span>{{ currentUserName }}</span>
            <span>{{ currentUser.position | capitalize }} <small>({{ currentUser.idCard }})</small></span>
          </div>

          <md-button @click.native.stop="logout()" class="md-dense md-icon-button md-list-action logout-button">
            <md-icon class="custom-icon md-accent">power_settings_new</md-icon>
            <md-tooltip md-direction="top">{{ 'global.~SALIR~' | translate }}</md-tooltip>
          </md-button>
          <md-divider></md-divider>
        </md-list-item>
          
      </md-list>

      <md-subheader>{{ 'organization.~TITULO~' | translate }}</md-subheader>

      <div class="custom-box organization">
        <multiselect 
          :maxHeight="400"
          class="custom-multiselect"
          v-model="currentOrgId" 
          :options="orgSmallList" 
          :custom-label="customLabel" 
          :placeholder="'users.~BUSCAR~' | translate"
          selectLabel=""
          :selectedLabel="'organization.~SELECCIONADO~' | translate"
          label="name" 
          track-by="id"
          :allow-empty="true"
          :hide-selected="false">
        </multiselect> 
      </div>

      <md-list>
        <md-list-item 
          :class="item.name" 
          v-for="(item, index) in items" 
          :key="index">
          <router-link exact :to="item.to">
            <md-icon>{{item.icon}}</md-icon>
            <span>{{ item.title | translate }}</span>
          </router-link>
          <md-list-expand v-if="item.subitems">
            <md-list>
              <md-list-item 
                class="md-inset" 
                v-for="(subitem, index) in item.subitems" 
                :key="index">
                <router-link exact :to="subitem.to">
                  <md-icon>{{item.icon}}</md-icon>
                  <span>{{item.title}}</span>
                </router-link>
              </md-list-item>
            </md-list>
          </md-list-expand>
        </md-list-item>
      </md-list>
    </div>
  </md-sidenav>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import find from 'lodash/find'
import pick from 'lodash/pick'

export default {
  name: 'sidenav',
  components: {
    Multiselect
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    logoOrg: String,
    loadingLogo: Boolean
  },
  data () {
    return {
      currentOrgIdTest: '',
      value: 1,
      image: null,
      imageId: ''
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.authentication.currentUser.data,
      currentOrgId: state => state.authentication.currentOrgId
    }),
    logoOrganization () {
      return this.logoOrg
    },
    currentUserName () {
      return `${this.currentUser.firstName} ${this.currentUser.lastName}`
    },
    currentOrgId: {
      get () {
        let orgId = this.$store.state.authentication.currentOrgId
        let list = this.currentUser.organizations
        return { id: orgId, name: find(list, { 'id': orgId }).name }
      },
      set (value) {
        const id = value.id
        this.$store.dispatch('changeOrg', id)
      }
    },
    orgSmallList () {
      const temp = []
      for (const n in this.currentUser.organizations) {
        temp.push(pick(this.currentUser.organizations[n], ['id', 'name']))
      }
      return temp
    }
  },
  methods: {
    toggleSidenav () {
      if (this.$refs['main-sidebar']) {
        this.$refs['main-sidebar'].toggle()
      }
    },
    closeSidenav () {
      if (this.$refs['main-sidebar']) {
        this.$refs['main-sidebar'].close()
      }
    },
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    },
    customLabel ({ name, id }) {
      return `${name}`
    }
  },
  mounted () {
    this.$events.$on('toggleSidenav', () => this.toggleSidenav())
    this.$events.$on('closeSidenav', () => this.closeSidenav())
  },
  beforeDestroy () {
    this.$events.$off('toggleSidenav')
    this.$events.$off('closeSidenav')
  }
}
</script>

<style scoped>

.logo-main {
  padding-top: 6px;
  width: 280px;
  margin-left: auto;
  margin-right: auto;
}

.main-sidebar.md-sidenav .md-toolbar {
  min-height: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.subheader-custom{
  font-size: 12px;
}

.custom-icon{
  font-size: 20px;
}

.custom-box{
  padding: 0px 16px 0px 16px;
}

.custom-multiselect{
  z-index: 10000 !important;
  font-size: 13px !important;
  min-height: 26px !important;
}
.md-subheader {
  min-height: 28px;
}

.custom-spinner {
  margin-left: 110px;
}

</style>



// WEBPACK FOOTER //
// sidenav.vue?dfe5c1f4